import {
  useEnterpriseCoursePageData,
  useIsEnterpriseCourseDataLoading,
} from 'bundles/unified-description-page-common/contexts/enterprise/EnterpriseBffCourseContext';
import {
  useEnterpriseSpecializationPageData,
  useIsEnterpriseS12nDataLoading,
} from 'bundles/unified-description-page-common/contexts/enterprise/EnterpriseBffSpecializationContext';

const useIsEmptyContentError = () => {
  const coursePageData = useEnterpriseCoursePageData();
  const isEnterpriseCourseDataLoading = useIsEnterpriseCourseDataLoading();
  const specializationPageData = useEnterpriseSpecializationPageData();
  const isEnterpriseS12nDataLoading = useIsEnterpriseS12nDataLoading();

  return !coursePageData && !specializationPageData && !isEnterpriseCourseDataLoading && !isEnterpriseS12nDataLoading;
};

export default useIsEmptyContentError;
